import React, { useState } from 'react';

import { withTracking } from '../../provider';
import { isMobileOrTablet } from '../../../../utils/browserDetection';
import CategorySearchFilterComponent from './component';
import { filterBarTrackingSource } from '../FilterBar/constant';

const CategorySearchFilter = ({
  type,
  injected: {
    tracking: { trackPanelOpen, trackPanelClose, trackButtonClick },
  },
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = isMobileOrTablet();

  const onClose = () => {
    if (trackPanelClose) {
      trackPanelClose(type);
    }

    setIsOpen(false);
  };

  const onToggle = () => {
    if (trackPanelOpen) trackPanelOpen(type);
    if (trackButtonClick) {
      trackButtonClick(type, { type: isOpen ? 'close' : 'open' });
    }

    setIsOpen(!isOpen);
  };

  return (
    <CategorySearchFilterComponent
      onToggle={onToggle}
      onClose={onClose}
      isOpen={isOpen}
      isMobile={isMobile}
      type={type}
      {...props}
    />
  );
};

export default withTracking(filterBarTrackingSource)(CategorySearchFilter);
